import { render, staticRenderFns } from "./EntityTypeColumnTemplateComponent.vue?vue&type=template&id=630c1522"
import script from "./EntityTypeColumnTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./EntityTypeColumnTemplateComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('630c1522')) {
      api.createRecord('630c1522', component.options)
    } else {
      api.reload('630c1522', component.options)
    }
    module.hot.accept("./EntityTypeColumnTemplateComponent.vue?vue&type=template&id=630c1522", function () {
      api.rerender('630c1522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/ColumnTemplates/EntityTypeColumnTemplateComponent.vue"
export default component.exports